import type { AdminLocale } from './adminLocale';
import { getAdminLocale } from './adminLocale';
import { en } from './messages/en';
import { ru } from './messages/ru';

const bundles: Record<AdminLocale, Record<string, string>> = { en, ru };

export function t(key: string, params?: Record<string, string | number>): string {
    const locale = getAdminLocale();
    let template = bundles[locale][key] ?? bundles.en[key] ?? key;
    if (params) {
        for (const [k, v] of Object.entries(params)) {
            template = template.split(`{${k}}`).join(String(v));
        }
    }
    return template;
}
